"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimCount = void 0;
const internal_1 = require("../../../../../internal");
const types_1 = require("../../../../../types");
/**
 * Handles all Claim Count Transfer Restriction related functionality
 */
class ClaimCount extends internal_1.TransferRestrictionBase {
    constructor() {
        super(...arguments);
        this.type = types_1.TransferRestrictionType.ClaimCount;
    }
}
exports.ClaimCount = ClaimCount;
//# sourceMappingURL=ClaimCount.js.map